/** download center title and content of configs */
export const DOWNLOAD_SUCCESS_MAP = {
  /** 钱包流水导出 */
  ONE_CLUB_WALLET_FLOW_EXPORT: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete',
  },
  /** OS运费账单导出 */
  ONE_CLUB_OS_FREIGHT_BILL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** OS运费账单明细导出 */
  ONE_CLUB_OS_FREIGHT_BILL_DETAIL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** OW运费账单导出 */
  ONE_CLUB_OW_FREIGHT_BILL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** OW运费账单明细导出 */
  ONE_CLUB_OW_FREIGHT_BILL_DETAIL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** 仓储费用账单导出 */
  ONE_CLUB_STORAGE_BILL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** 仓储费用账单明细导出 */
  ONE_CLUB_STORAGE_BILL_DETAIL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** COD账单导出 */
  ONE_CLUB_COD_BILL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  /** COD账单明细导出 */
  ONE_CLUB_COD_BILL_DETAIL: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
  common: {
    title: 'download.task.complete.bill',
    content: 'download.task.complete.bill.content',
  },
}
export const DOWNLOAD_FAILED_MAP = {
  ONE_CLUB_WALLET_FLOW_EXPORT: {
    title: 'download.task.failed.bill',
    content: 'download.task.failed',
  },
}

export const DOWNLOAD_CENTER_BUTTON_TYPE_META = {
  DOWNLOAD: 'download',
}
